<template lang='pug'>
  .container
    article
      h2 Kanzleiprofil
      p
        | Rechtsanwalt Schommer begann seine Tätigkeit im Jahre 1988 bei den Rechtsanwälten Ulrich Behr, Ulrike Lachmann und Robert Neixler in Berlin Charlottenburg und wurde 1993 Partner der Sozietät BLN & Partner GbR (Rechtsanwälte * Notare * Wirtschaftsprüfer) bis zu deren Auflösung Ende 2018. 
        | Er war dort vornehmlich im Bereich des zivilen Bau- und Architektenrecht tätig und betreute mehr als 27 Jahre zahlreiche mittelständische Bauunternehmungen sowie Architektenbüros. 
        | Seit 2006 ist Rechtsanwalt Schommer Fachanwalt für Bau- und Architektenrecht.
      p
        | Das Kanzleiprofil wurde und wird auch weiterhin nahezu ausschließlich geprägt durch das zivile Baurecht und Architektenrecht. 
        | Beratung und Interessenvertretung auf hohem fachlichem Niveau ist sein vornehmstes Anliegen.
        | Weiteres Leitmotiv seiner Anwaltstätigkeit ist der enge Kontakt und das Vertrauensverhältnis zu den Mandanten.
      p
        | Mit vielen der Mandanten, insbesondere den weiterhin betreuten mittelständischen Bauunternehmen und Architektenbüros, verbinden Rechtsanwalt Schommer langfristige, teils schon mehr als 2 Jahrzehnte dauernde Beratungsverträge.
        | Auch die sehr lange Zusammenarbeit mit und Mandatierung durch Architekten – Haftpflichtversicherungen bestätigen seine Reputation und erweiterten kontinuierlich seinen Erfahrungshorizont.

      p
        | Sein Bestreben ist es, unnötiges Prozessieren durch kompetente Vorfeldberatung möglichst zu vermeiden.
        | Unumgängliche gerichtliche Auseinandersetzung scheut er dennoch nicht, denn Herr Rechtsanwalt Schommer verfügt über vielfältige Erfahrungen und eine beachtliche Erfolgsquote als Prozessanwalt. 

      p
        | Seine fachliche Kompetenz ist darüber hinaus bereits seit 2006 durch die Fachanwaltschaft für Bau-und Architektenrecht, regelmäßige jährliche Fortbildungsveranstaltungen und zusätzlich durch Publikationen in Fachzeitschriften, durch Referententätigkeiten und Qualifizierungsveranstaltungen, u.a. in Bauunternehmen zur Mitarbeiter-/Bauleiterschulungen ausgewiesen.

</template>

<script>
  export default {
    name: 'Kanzleiprofil',
    data () {
      return {}
    }
  }
</script>

<style lang='stylus' scoped>
</style>



// WEBPACK FOOTER //
// src/components/content/Kanzleiprofil.vue